import React from 'react';
import b from 'b_';
import cn from 'classnames';
import FlagStore from '../../stores/FlagStore';
import { ObservableCheckbox } from '../Checkbox';
import './ConsoleFragments.css';

const block = b.lock('ConsoleCheckbox');

export default function ConsoleCheckbox({ flagStore, className, children, ...props }) {
    return <label
        className={cn(block(), className)}
        {...props}
    >
        <ObservableCheckbox store={flagStore} />
        <span className={block('Label')}>{children}</span>
    </label>;
}

ConsoleCheckbox.propTypes = {
    flagStore: FlagStore.PropType.isRequired,
};
